<template>
  <panel-layout
    id="customer-panel"
    :loading="loading"
    :show-footer="false"
    class="h-full w-full flex flex-col bg-gray-100"
  >
    <template #heading>
      <Heading v-if="customer" :customer="customer" class="pb-3 pt-4" @selectTab="handleSelectTab" />
    </template>

    <template v-if="customer" #actions-right>
      <Actions
        v-model:customer="customer"
        v-model:loading="loading"
      />
    </template>

    <template v-if="customer">
      <Tabs ref="tabs" v-model:customer="customer" />
    </template>

    <o-error :error="error" />
  </panel-layout>
</template>
<script setup lang="ts">
// @ts-ignore
import Tabs from '@/components/customer/profile/tabs.vue'
// @ts-ignore
import Heading from '@/components/customer/profile/heading.vue'
// @ts-ignore
import Actions from '@/components/customer/profile/actions.vue'

// @ts-ignore
import PanelLayout from '@/components/panel/PanelLayout.vue'

// @ts-ignore
import {
  OTabs,
  OTab,
} from '@/components/elements'

import { usePanel } from '~/composables/usePanel'

const props = defineProps<{ id?: string }>()

const { $api, $bus } = useNuxtApp()

const panel = usePanel()

const tabs = ref<any>()

const customer = ref<any>(null)
const error = ref<any>(false)
const loading = ref(true)

const uid = Math.random().toString(36).slice(2)

const fetchCustomer = async (id?: string) => {
  loading.value = true

  try {
    if (id) {
      const result = (await $api.customer.get(id)).data
      customer.value = result
    }
  } catch (e) {
    error.value = e
  }

  loading.value = false
}

const handleSelectTab = (tab: string) => {
  tabs.value?.selectTab('#' + tab)
}

watch(() => props.id, (id) => fetchCustomer(id), { immediate: true })

onMounted(() => {
  $bus.on.updated('Customer', uid, (c: any) => {
    if (c?.idCustomer === customer.value?.idCustomer) {
      fetchCustomer(props.id)
    }
  })
})

onBeforeUnmount(() => {
  $bus.off.all(uid)
})
</script>
